import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

// Keep layout values in sync with styles.container in WorkforcePermissionsView.tsx.
const styles = cssMap({
	container: {
		width: '100%',
		maxWidth: '1290px',
		marginInline: 'auto',
		paddingTop: token('space.400'),
		paddingRight: token('space.300'),
		paddingLeft: token('space.300'),
	},
	// Page heading (~28px h1)
	heading: {
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.small'),
		height: '28px',
		width: '200px',
	},
});

export const WorkforcePermissionsSkeleton = (): React.JSX.Element => (
	<Box
		xcss={styles.container}
		aria-hidden="true"
		testId="project-settings-service-desk-workforce-permissions.loading-skeleton"
	>
		<Box xcss={styles.heading} />
	</Box>
);
